import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

export const SubtitleWrapperStyled = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.028rem;
  text-align: center;
  color: ${colors.neutral[900]};
  position: relative;
  overflow: hidden;
  margin: 2rem 0;
`;

export const SubtitleTextStyled = styled.span<{ $narrow: boolean }>`
  display: inline-block;
  vertical-align: baseline;
  position: relative;
  padding: 0 1rem;

  /* Lines */
  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    border-top: 0.1rem solid ${colors.neutral[300]};
    width: 100%;
  }

  &::before {
    right: 100%;
  }

  &::after {
    left: 100%;
  }

  ${({ $narrow }): CSSProp =>
    $narrow &&
    css`
      &::before,
      &::after {
        width: 40rem;
      }

      @media (width <= 450px) {
        padding: 0 1rem;

        &::before,
        &::after {
          display: block;
        }
      }
    `}

  @media (width <= 450px) {
    padding: 0;

    &::before,
    &::after {
      display: none;
    }
  }
`;
